import React from "react";
import camilaCabello from "../../../media/images/camila-cabello1.jpg";
import arianaGrande from "../../../media/images/ariana-grande1.jpg";
import alanWalker from "../../../media/images/alan-walker1.jpg";
import bts from "../../../media/images/bts1.jpg";
import lilNasX from "../../../media/images/lil-nas-x1.jpg";
import ritaOra from "../../../media/images/rita-ora1.jpg";
import dojaCat from "../../../media/images/doja-cat1.jpg";
import taylorSwift from "../../../media/images/taylor-swift1.jpg";
import bebeRexha from "../../../media/images/bebe-rexha1.jpg";
import selenaGomez from "../../../media/images/selena-gomez1.jpg";
import { Link } from "react-router-dom";

const topArtists = [
  {
    name: "Camila Cabello",
    img: camilaCabello,
  },
  {
    name: "BTS",
    img: bts,
  },
  {
    name: "Ariana Grande",
    img: arianaGrande,
  },
  {
    name: "Lil Nas X",
    img: lilNasX,
  },
  {
    name: "Alan Walker",
    img: alanWalker,
  },
  {
    name: "Doja Cat",
    img: dojaCat,
  },
  {
    name: "Rita Ora",
    img: ritaOra,
  },
  {
    name: "Selena Gomez",
    img: selenaGomez,
  },
  {
    name: "Taylor Swift",
    img: taylorSwift,
  },
  {
    name: "Bebe Rexha",
    img: bebeRexha,
  },
];

const TopArtists = () => {
  return (
    <div className="top-artists">
      <div className="header">
        <h3>Top Artisis</h3>
        <p>See All</p>
      </div>
      <div className="artists">
        {topArtists.map((artist) => (
          <Link to="/artists/artist" key={artist.name} className="artist">
            <img src={artist.img} alt={artist.name} />
            <p>{artist.name}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default TopArtists;
